module.exports = __webpack_public_path__ + "img/delivery-guy.0bbb5e30.svg";